import React, { Component } from 'react';

class RowHistorialTarjetas extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        let { HistorialTarjetas, indice } = this.props;
        
        let claseBackground = "";
        let indiceAdicional = 0;
        let vencimiento = HistorialTarjetas.FechaVigenciaDesde.replace("-","/") + " - " + HistorialTarjetas.FechaVigenciaHasta.replace("-","/");
        
        if (HistorialTarjetas.Vinculo.toString().trim() == "Titular") {
            if (indice % 2 == 0)
                claseBackground = "backgroundVerdeClaro"
            else
                claseBackground = "backgroundVerdeOscuro"
        }
        else{
            if (indiceAdicional % 2 == 0)
                claseBackground = "backgroundGrisClaro"
            else
                claseBackground = "backgroundGrisOscuro"
            
            indiceAdicional ++;
        }


        return (
            <tr className={claseBackground}>
                <td>
                    {HistorialTarjetas.Denominacion}
                </td>
                <td>
                    {HistorialTarjetas.Numero}
                </td>
                <td>
                    {HistorialTarjetas.Descripcion}
                </td>
                <td>
                    {HistorialTarjetas.Denominacion4taLinea}
                </td>
                <td>
                    {HistorialTarjetas.FechaHabilitacion}
                </td>
                <td>
                    {vencimiento}
                </td>
            </tr>
        );
    }
}

export default RowHistorialTarjetas;